<sh-form-group
    [invalid]="isControlInvalid$ | async"
    [required]="false"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [describeLabelId]="describeLabelId"
    [errorMsg]="errorMsg"
    [id]="id"
>
    <ng-content></ng-content>

    <ng-container *ngIf="canBeIndeterminate; then complex; else simple"> </ng-container>

    <ng-template #complex>
        <med-form-permissions-complex-base
            [indeterminateMsg]="indeterminateMsg"
            [required]="(isControlRequired$ | async) && !isBatchEdit"
            [isDisabled]="control.disabled"
            [formControl]="control"
            [readLabel]="readLabel"
            [writeLabel]="writeLabel"
            [exportLabel]="exportLabel"
            [noneSelectedMsg]="noneSelectedMsg"
            [multipleSelectedMsg]="multipleSelectedMsg"
            [allSelectedMsg]="allSelectedMsg"
            [openDirection]="openDirection"
            [errorMsg]="errorMsg"
            [id]="id"
            [isBatchEdit]="isBatchEdit"
        ></med-form-permissions-complex-base>
    </ng-template>
    <ng-template #simple>
        <med-form-permissions-base
            [required]="(isControlRequired$ | async) && !isBatchEdit"
            [isDisabled]="control.disabled"
            [formControl]="control"
            [readLabel]="readLabel"
            [writeLabel]="writeLabel"
            [exportLabel]="exportLabel"
            [noneSelectedMsg]="noneSelectedMsg"
            [multipleSelectedMsg]="multipleSelectedMsg"
            [allSelectedMsg]="allSelectedMsg"
            [openDirection]="openDirection"
            [errorMsg]="errorMsg"
            [id]="id"
            [isBatchEdit]="isBatchEdit"
        ></med-form-permissions-base>
    </ng-template>
</sh-form-group>
